ready().then(function() {
    const accordeon = () => {
        const acc = document.getElementsByClassName("is-accordeon");
        let i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function(e) {
                e.preventDefault();
                this.classList.toggle("accordeon-active");

                const panel = this.nextElementSibling;

                if ((panel.style.maxHeight) || (panel.classList.contains("is-open"))) {
                    panel.classList.remove("is-open")
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }
    }
    accordeon();
});